module.exports = __webpack_public_path__ + "/public/images/676227963907c0436cc9e465489a38d6.png";